/**
 * spinner.tsx — minimal loading spinner primitive (T-072 item 1).
 *
 * Wraps lucide-react's Loader2 with the Tailwind spin animation. Inherits the
 * current text color, so it sits naturally inside buttons and inline slots.
 * role="status" + aria-label make the loading state announced to assistive tech.
 */
import { Loader2 } from 'lucide-react'
import { cn } from '@/lib/utils'

export interface SpinnerProps {
  /** Icon size in px (default 16). */
  size?: number
  className?: string
  /** Accessible label announced by screen readers (default "Loading"). */
  label?: string
}

export function Spinner({ size = 16, className, label = 'Loading' }: SpinnerProps) {
  return (
    <Loader2
      role="status"
      aria-label={label}
      size={size}
      className={cn('animate-spin', className)}
      aria-hidden={false}
    />
  )
}
